<template>
    <div>
        <v-row>

            <ActionDropdown 
                :items="actions"
                context="AzGroups"
                :alvqa="alvqa"
                cols="3"
            />

            <v-col 
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="AzGroups" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
                <v-spacer />
            <v-col 
                cols="2" 
                align-self="center"
            >
                <BaseButton
                    label="lang_AZ_GROUPS_BUTTON_CAPTION_NEW_GROUP"
                    :to="{name: editForm, params: { alvId: 'new'}}"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ActionDropdown from '@/components/_actions/ActionDropdown'

export default {
    name: "AzGroupsTopSlot",
    components: {
        BaseHeaderStats,
        BaseButton,
        ActionDropdown,
    },
    data() {
        return {
            editForm: "AzGroupsEdit",
            alvqa: "az-groups"
        }
    },
    computed: {
        actions() {
            return [
                {
                    text: this.$t("lang_AZ_PERSONS_ACTION_OPTION_PRINT_A6_LABELS"),
                    value: "printAzGroupsA6Labels",
                    alvqa: this.alvqa + '-list-action-dropdown-print-a6-labels'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'),
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ASSIGN_MAPPINGS'),
                    value: 'assignTemplates',
                    alvqa: this.alvqa + '-list-action-dropdown-assign-templates'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                },
            ]
        }
    },

}
</script>